/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateElectronBeamQualityDto } from './CreateElectronBeamQualityDto';
import {
    CreateElectronBeamQualityDtoFromJSON,
    CreateElectronBeamQualityDtoFromJSONTyped,
    CreateElectronBeamQualityDtoToJSON,
} from './CreateElectronBeamQualityDto';

/**
 * 
 * @export
 * @interface CreateElectronBeamQualitiesDto
 */
export interface CreateElectronBeamQualitiesDto {
    /**
     * 
     * @type {Array<CreateElectronBeamQualityDto>}
     * @memberof CreateElectronBeamQualitiesDto
     */
    values?: Array<CreateElectronBeamQualityDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateElectronBeamQualitiesDto
     */
    visible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualitiesDto
     */
    $type?: CreateElectronBeamQualitiesDtoTypeEnum;
}


/**
 * @export
 */
export const CreateElectronBeamQualitiesDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationCreateElectronBeamQualitiesDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreateElectronBeamQualitiesDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateElectronBeamQualitiesDtoTypeEnum = typeof CreateElectronBeamQualitiesDtoTypeEnum[keyof typeof CreateElectronBeamQualitiesDtoTypeEnum];


/**
 * Check if a given object implements the CreateElectronBeamQualitiesDto interface.
 */
export function instanceOfCreateElectronBeamQualitiesDto(value?: unknown): value is CreateElectronBeamQualitiesDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateElectronBeamQualitiesDtoTypeEnum)[0];
}

export function CreateElectronBeamQualitiesDtoFromJSON(json: any): CreateElectronBeamQualitiesDto {
    return CreateElectronBeamQualitiesDtoFromJSONTyped(json, false);
}

export function CreateElectronBeamQualitiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateElectronBeamQualitiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'values': !exists(json, 'values') ? undefined : (json['values'] === null ? null : (json['values'] as Array<any>).map(CreateElectronBeamQualityDtoFromJSON)),
        'visible': !exists(json, 'visible') ? undefined : json['visible'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateElectronBeamQualitiesDtoToJSON(value?: CreateElectronBeamQualitiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'values': value.values === undefined ? undefined : (value.values === null ? null : (value.values as Array<any>).map(CreateElectronBeamQualityDtoToJSON)),
        'visible': value.visible,
        '$type': value.$type,
    });
}

